import Vuex from 'vuex';
import Vue from 'vue';
import * as actions from './actions';
import getters from './getters';

import login from './modules/login';
import overall from './modules/overall';
import basedata from './modules/basedata';
import systemnotice from './modules/systemnotice';
import unapprove from './modules/unapprove';
import createVuexAlong from 'vuex-along'


Vue.use(Vuex);

const debug = !(global.NODE_ENV == 'production' || global.NODE_ENV == 'test');
export default new Vuex.Store({
  strict: debug,
  actions,
  getters,
  modules: {
    login,
    overall,
    basedata,
    systemnotice,
    unapprove,
  },
  plugins: [
    createVuexAlong({
      name: "roche-event-planning",
      session: {list:[], isFilter:true},
      justSession: true,
    })
  ]
});



// WEBPACK FOOTER //
// ./src/store/index.js